var map = {
	"./add.svg": 59614,
	"./arrowdown.svg": 27196,
	"./arrowright.svg": 84149,
	"./complete.svg": 49141,
	"./consulting.svg": 19318,
	"./distribution.svg": 45473,
	"./document.svg": 1290,
	"./help.svg": 9977,
	"./holdon.svg": 67380,
	"./hotel.svg": 29180,
	"./maintenance.svg": 63169,
	"./movie.svg": 3218,
	"./no.svg": 95361,
	"./personal.svg": 87182,
	"./problem.svg": 98787,
	"./star.svg": 68019,
	"./yes.svg": 25983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;